import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';

export default function SelectedTopic({ topic, index }) {
  const content = (
    <>
      <i
        style={{
          WebkitMaskImage: `url(${topic.attributes.icon})`,
          maskImage: `url(${topic.attributes.icon})`,
        }}
      />
      <span className="text-content">{topic.attributes.title}</span>
      <i className="small-icon grab-icon ms-auto" />
    </>
  );

  const className = topic.attributes.special_type === 'employee_choice' ? 'employee-choice' : '';
  return (
    <Draggable draggableId={topic.id} index={index} type="TOPIC">
      {(provided, snapshot) => (
        <>
          <div
            className={`topic-to-select icon-with-text ${className}`}
            ref={provided.innerRef}
          // eslint-disable-next-line react/jsx-props-no-spreading
            {...provided.draggableProps}
          // eslint-disable-next-line react/jsx-props-no-spreading
            {...provided.dragHandleProps}
            style={
              provided.draggableProps
                .style
            }
          >
            {content}
          </div>
          {snapshot.isDragging && (
          <div className={`topic-to-select icon-with-text dnd-copy ${className}`}>
            {content}
          </div>
          )}
        </>
      )}
    </Draggable>
  );
}

SelectedTopic.propTypes = {
  topic: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};
